// here we will add all the navigation links that exists and we will need an extra flag
// 'hideFromView: true' to check if we need to display on sidenav
// depeding on the privilege

export const navigationLinks = [
  {
    title: 'Dashboard',
    icon: {
      src: '../../assets/img/dashboard_icon.svg',
      inlineStyle: 'width:22px;height:22px;position:relative;left:-2px',
    },
    active: false,
    routerLink: '/dashboard',
    privilege: 'masterDashboard',
    children: [],
    hideIfNoPrivileges: true,
    // callback: () => {
    //   this.closeParentTrigger();
    // },
  },
  {
    title: 'Nudge',
    icon: {
      src: '../../assets/img/nudge_icon.svg',
      inlineStyle: 'width:18px;height:18px',
    },
    active: false,
    routerLink: '/master-preview',
    privilege: 'masterPreview',
    children: [],
    // callback: () => {
    //   this.closeParentTrigger();
    // },
  },
  {
    title: 'NudgeGPT',
    icon: {
      src: '../../assets/img/genAI_nudge_icon.svg',
      inlineStyle: 'width:18px;height:18px',
    },
    active: false,
    routerLink: '/nudgeGPT',
    privilege: 'genAiNudges',
    children: [],
  },
  {
    title: 'Diagnostic',
    icon: {
      src: '../../assets/img/diagnostic_icon.svg',
      inlineStyle: 'width:18px;height:18px',
    },
    active: false,
    routerLink: '/diagnostic',
    privilege: 'bugTrackingOverall',
    children: [],
    // callback: () => {
    //   this.closeParentTrigger();
    // },
  },
  {
    title: 'User Insights',
    icon: {
      src: '../../assets/img/recorder_icon.svg',
      inlineStyle: 'width:20px;height:20px',
    },
    active: false,
    routerLink: '/recording',
    privilege: 'recording_overall',
    children: [],
    // callback: () => {
    //   this.closeParentTrigger();
    // },
  },
  {
    title: 'Organic',
    icon: {
      src: '../../assets/img/organic_icon.svg',
      inlineStyle: 'width:19px;height:19px',
    },
    active: false,
    privilege: '',
    children: [
      {
        title: 'Getting Started',
        routerLink: '/seo/getting-started',
        privilege: 'seo_getting_started',
        materialIcon: 'dashboard',
      },
      {
        title: 'AI Audit',
        routerLink: '/seo/ai-analysis',
        privilege: 'seo_ai-analysis',
        materialIcon: 'query_stats',
        disable_on_zero_projects: true,
      },
      {
        title: 'AI Audit Issue',
        routerLink: '/seo/ai-analysis/issue',
        privilege: 'seo_ai-analysis',
        materialIcon: 'query_stats',
        disable_on_zero_projects: true,
        hideFromView: true,
      },
      {
        title: 'Content',
        routerLink: '/seo/content',
        privilege: 'seo_content',
        materialIcon: 'text_snippet',
        disable_on_zero_projects: true,
      },
      {
        title: 'Rank Tracker',
        routerLink: '/seo/positions',
        privilege: 'seo_position-tracking',
        materialIcon: 'show_chart',
        disable_on_zero_projects: true,
      },
      // {
      //   title: 'Backlink Prediction',
      //   routerLink: '/seo/backlink-prediction',
      //   privilege: 'seo_backlinks',
      //   svgIcon: 'link_svg_icon',
      //   disable_on_zero_projects: true,
      // },
      {
        title: 'Backlinks',
        routerLink: '/seo/backlinks',
        privilege: 'seo_backlinks',
        svgIcon: 'link_svg_icon',
        disable_on_zero_projects: true,
      },
      {
        title: 'Keywords',
        routerLink: '/seo/keywords',
        privilege: 'seo_projects',
        materialIcon: 'leaderboard',
        disable_on_zero_projects: true,
      },
      // {
      //   title: 'Relevance',
      //   routerLink: '/seo/relevance',
      //   privilege: 'seo_backlinks_measure-relevancy',
      // },
      // {
      //   title: 'Automations',
      //   routerLink: '/seo/automations',
      //   privilege: 'seo_automations',
      // },
      // {
      //   title: 'Scripts',
      //   routerLink: '/seo/scripts',
      //   privilege: 'seo_scripts',
      // },
      // {
      //   title: 'Technicals',
      //   routerLink: '/seo/technicals',
      //   privilege: 'seo_technicals',
      // },
      // {
      //   title: 'On Page',
      //   routerLink: '/seo/on-page',
      //   privilege: 'seo_on-page',
      // },
      {
        title: 'Pages',
        routerLink: '/seo/pages',
        privilege: 'seo_pages',
        hideFromView: true,
        disable_on_zero_projects: true,
      },
      {
        title: 'Competitors',
        routerLink: '/seo/competitors',
        privilege: 'seo_projects',
        materialIcon: 'groups',
      },
      {
        title: 'Projects',
        routerLink: '/seo/projects',
        privilege: 'seo_projects',
        materialIcon: 'format_list_bulleted',
      },
      {
        title: 'Integrations',
        routerLink: '/seo/integrations',
        privilege: 'seo_projects',
        materialIcon: 'integration_instructions',
      },
    ],
    // callback: () => {
    //   this.parentSEOClick();
    // },
  },
  {
    title: 'Merchandise',
    icon: {
      src: '../../assets/img/merchandising_icon.svg',
      inlineStyle: 'width:16px;height:16px;margin-left:2px',
    },
    active: false,
    routerLink: '/merchandising',
    privilege: 'merchandising',
    children: [],
    // callback: () => {
    //   this.closeParentTrigger();
    // },
  },
  {
    title: 'Merchandise Product',
    icon: {},
    active: false,
    routerLink: '/merchandising/product-details',
    privilege: 'merchandising',
    children: [],
    hideFromView: true,
  },
  {
    title: 'Model Automation',
    icon: {},
    active: false,
    routerLink: '/model-automation',
    privilege: 'modelAutomationModels',
    children: [],
    hideFromView: true,
  },
  {
    title: 'Agents',
    icon: {
      src: '../../assets/img/automations_icon_1.svg',
      inlineStyle: 'width:20px;height:16px',
    },
    active: false,
    routerLink: '/agents',
    privilege: 'automationsOverview',
    children: [],
  },
  {
    title: 'Signals',
    icon: {
      src: '../../assets/img/signals_icon.svg',
      inlineStyle: 'width:20px;height:16px',
    },
    active: false,
    routerLink: '/signals',
    privilege: 'signals_insights',
    children: [],
    hideIfNoPrivileges: true,
  },
  {
    title: 'Purchase Insights',
    icon: {
      src: '../../assets/img/purchase_insights-v2.svg',
      inlineStyle: 'width:21px;height:18px',
    },
    active: false,
    routerLink: '/purchase-insights',
    privilege: 'purchaseInsights',
    children: [],
    hideIfNoPrivileges: true,
  },
  {
    title: 'Purchase Insights Detailed',
    icon: {
      src: '../../assets/img/purchase_insights.svg',
      inlineStyle: 'width:20px;height:16px',
    },
    active: false,
    routerLink: '/purchase-insights/detailed/*',
    privilege: 'purchaseInsights',
    children: [],
    hideFromView: true,
  },
  {
    title: 'Ad Copilot',
    icon: {
      src: '../../assets/img/ad_copilot_icon.svg',
      inlineStyle: 'width:20px;height:16px',
    },
    active: false,
    // routerLink: '/ads',
    privilege: 'copilot_ads',
    children: [
      {
        title: 'Getting Started',
        routerLink: '/ads/getting-started',
        privilege: 'copilot_ads',
        materialIcon: 'dashboard',
        // disable_on_zero_projects: true,
      },
      {
        title: 'AI Audit',
        routerLink: '/ads/ai-audit',
        privilege: 'ads_ai-audit',
        materialIcon: 'query_stats',
        disable_on_zero_projects: true,
      },
      {
        title: 'Competitors',
        routerLink: '/ads/competitors',
        privilege: 'ads_competitor',
        materialIcon: 'integration_instructions',
        disable_on_zero_projects: true,
      },
      {
        title: 'Projects',
        routerLink: '/ads/projects',
        privilege: 'ads_projects',
        materialIcon: 'format_list_bulleted',
        // disable_on_zero_projects: true,
      },
      {
        title: 'Integrations',
        routerLink: '/ads/integrations',
        privilege: 'ads_integrations',
        materialIcon: 'integration_instructions',
        disable_on_zero_projects: true,
      },
    ],
    hideIfNoPrivileges: true,
  },
  {
    title: 'Website Analysis',
    icon: {
      src: '../../assets/img/website_analysis_icon.svg',
      inlineStyle: 'width:20px;height:16px',
    },
    active: false,
    routerLink: '/website-analysis',
    privilege: 'websiteAnalysis',
    children: [],
    hideIfNoPrivileges: true,
  },
  {
    title: 'Note-taking',
    icon: {
      src: '../../assets/img/nudge_icon.svg',
      inlineStyle: 'width:18px;height:18px',
    },
    active: false,
    routerLink: '/notetaking',
    children: [],
    privilege: 'notetaking',
    hideIfNoPrivileges: true,
  },
  {
    title: 'Website Audit',
    icon: {
      src: '../../assets/img/website_analysis_icon.svg',
      inlineStyle: 'width:20px;height:16px',
    },
    active: false,
    routerLink: '/website-audit',
    privilege: 'websiteAudit',
    children: [],
    hideIfNoPrivileges: true,
  },
  {
    title: 'Note-taking AI Chat',
    icon: {
      src: '../../assets/img/nudge_icon.svg',
      inlineStyle: 'width:18px;height:18px',
    },
    active: false,
    routerLink: '/notetaking/ai-chat/*',
    privilege: 'notetaking',
    children: [],
    hideIfNoPrivileges: true,
    hideFromView: true,
  },
  {
    title: 'LinkedIn',
    icon: {
      src: '../../assets/img/linkedIn_icon.svg',
      inlineStyle: 'width:20px;height:16px;position:relative;top:-1px',
    },
    active: false,
    routerLink: '/linkedin',
    privilege: 'linkedinOverall',
    children: [],
    hideIfNoPrivileges: true,
  },
  {
    title: 'invoices',
    icon: {
      src: '',
      inlineStyle: '',
    },
    active: false,
    routerLink: '/invoices',
    privilege: 'masterInvoices',
    children: [],
    hideFromView: true,
  },
  {
    title: 'Organic Billing',
    icon: {
      src: '',
      inlineStyle: '',
    },
    active: false,
    routerLink: '/seo/billing',
    privilege: 'seo_billing',
    children: [],
    hideFromView: true,
  },
  {
    title: 'Trace Error',
    icon: {
      src: '',
      inlineStyle: '',
    },
    active: false,
    routerLink: '/diagnostic/trace-error',
    privilege: 'traceError',
    children: [],
    hideFromView: true,
  },
  {
    title: 'User Permissions',
    icon: {
      src: '',
      inlineStyle: '',
    },
    active: false,
    routerLink: '/user-permissions',
    privilege: 'userPermissions',
    children: [],
    hideFromView: true,
  },
  {
    title: 'Experiments View',
    icon: {
      src: '',
      inlineStyle: '',
    },
    active: false,
    routerLink: '/master-experiment-view',
    privilege: 'masterAIExperiments',
    children: [],
    hideFromView: true,
  },
  {
    title: 'User Management',
    icon: {
      src: '',
      inlineStyle: '',
    },
    active: false,
    routerLink: '/user-management',
    privilege: 'masterUserManagement',
    children: [],
    hideFromView: true,
  },
  {
    title: 'Backlink Freelancer',
    icon: {
      src: '../../assets/img/automations_icon_1.svg',
      inlineStyle: 'width:20px;height:16px',
    },
    active: false,
    privilege: 'backlink_freelancer',
    children: [
      {
        title: 'Overview',
        routerLink: '/seo/backlinks-overview',
        privilege: 'backlink_freelancer',
        materialIcon: 'dashboard',
      },
      {
        title: 'My Listings',
        routerLink: '/seo/my-listings',
        privilege: 'backlink_freelancer_my-listings',
        materialIcon: 'create_new_folder',
      },
    ],
  },
  // {
  //   title: 'Maintenance',
  //   icon: {
  //     src: '',
  //     inlineStyle: '',
  //   },
  //   active: false,
  //   routerLink: '/organic-maintenance',
  //   privilege: '',
  //   children: [],
  //   hideFromView: true,
  // },
];
